<template>
    <div class="register" :style="{height:`${contentHeight}rem`}">
        <turnBack :content='content' :url='url' style="color:#FFF" />
        <div style="display: flex;flex-direction: column;align-items: center;margin-top:2rem">
            <img src="@/assets/img/news/APP ICON.png" alt="logo" style="width:5rem;margin:0px 10px">
        </div>
        <div >
            <el-form class="loginForm" ref="form" :model="form" style="margin:2rem 3rem">
                <el-form-item >
                    <img src="@/assets/img/login/icon_login_user.png" alt="logo" style="width:1.5rem;height:1.6rem;margin-right:10px">
                    <el-input v-model="loginForm.phone" placeholder="手机号码"></el-input>
                </el-form-item>
                <el-form-item >
                    <img src="@/assets/img/login/icon_login_code.png" alt="logo" style="width:1.5rem;height:1.6rem;margin-right:10px">
                    <el-input v-model="loginForm.phone" placeholder="验证码"></el-input>
                </el-form-item>
                <el-form-item >
                    <img src="@/assets/img/login/icon_login_pwd.png" alt="logo" style="width:1.5rem;height:1.6rem;margin-right:10px">
                    <el-input v-model="loginForm.password" placeholder="请输入密码"></el-input>
                </el-form-item>
                <el-form-item >
                    <img src="@/assets/img/login/icon_login_pwd.png" alt="logo" style="width:1.5rem;height:1.6rem;margin-right:10px">
                    <el-input v-model="loginForm.password" placeholder="请再次输入密码"></el-input>
                </el-form-item>
                <el-button type="primary" @click="onLogin" style="background:#00999d;width:100%;border:1px solid #00999d">注册</el-button>
            </el-form>
        </div>
    </div>
</template>
<script>
import turnBack from '@/components/turnBack'

export default {
    components:{
        turnBack,
    },
    data(){
        return {
            contentHeight:0,
            content:'免费注册',
            url:'/',
            loginForm:{
                password: "",
                phone: "",
            }
        }
    },
    mounted(){
        this.contentHeight = document.documentElement.clientHeight/16
    },
    methods:{
        onLogin(){

        },
        GotoPath(url){
            this.$router.push({ path: url })
        }
    }
}
</script>
<style lang="less" >
.register{
    background: url("~@/assets/img/login/icon_login_bg.png") 0 0 / cover;
    width: 100%;
    height: 100%;
    color: #FFF;
    .loginForm{
        .el-form-item{
            border-bottom: 1px solid #FFF;
        }
        .el-form-item__content{
            display: flex;
            align-items: center;
        }
        .el-input__inner{
            background: transparent;
            border: 0px;
        }
    }
}
</style>